import type { CustomerTimelineCallEventEntry } from "@repo/app-types/entities/performanceCustomer";
import type { CustomerInteractionCallEvent } from "@repo/app-types/entities/teammatePerformanceSummary";
import type { CustomerTimelineRow } from "@repo/ui/customerTimeline/customerTimeline";
import { CustomerTimelineRowDetails } from "@repo/ui/customerTimeline/customerTimelineRowDetails";
import {
  IconArrowForwardUp,
  IconPhoneCall,
  IconPhoneOff,
  IconPhoneOutgoing,
} from "@tabler/icons-react";
import type { ReactNode } from "react";
import {
  callActivityLabel,
  callFailureReasonLabel,
} from "../../teammatePerformance/callActivityColumns.js";
import {
  buildCustomerTimelineParticipant,
  type CustomerTimelineRowOptions,
} from "./timelineRowHelpers.js";

/** A voice agent's call with no recording to show, and why, if it failed. */
export function renderCallEventRow(
  entry: CustomerTimelineCallEventEntry,
  options: CustomerTimelineRowOptions,
): Pick<CustomerTimelineRow, "icon" | "content"> {
  const { type, error_code: errorCode } = entry.event;
  const reason =
    errorCode === undefined ? undefined : callFailureReasonLabel[errorCode];
  return {
    icon: callEventIcon[type],
    content: (
      <CustomerTimelineRowDetails
        title={
          reason
            ? `${callActivityLabel[type]} — ${reason}`
            : callActivityLabel[type]
        }
        onOpen={() => options.openInteraction(entry.grading_id)}
        participants={[buildCustomerTimelineParticipant(entry.teammate)]}
      />
    ),
  };
}

const callEventIcon: Record<CustomerInteractionCallEvent["type"], ReactNode> = {
  call_started: <IconPhoneOutgoing className="size-4" />,
  call_answered: <IconPhoneCall className="size-4" />,
  call_not_answered: <IconPhoneOff className="size-4" />,
  call_forwarded: <IconArrowForwardUp className="size-4" />,
  call_failed: <IconPhoneOff className="size-4" />,
};
